import { Button } from "react-bootstrap";
import PageTemplate from "../../templates/Pagetemplate";
import BreadCrumb from "../../molecules/BreadCrumb";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import BranchForm from "../../organisms/BranchForm";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { showAlert } from "../../../../reducer/alertSlice";
import axios from "axios";
import { useCheckDirtyField, useRefresh } from "../../../common/hook";


const Wrap = styled.div`
    .form-label {
        width: 150px;

        & + div[class^=col] {
            flex: 1 1;
        }
    }

    .form-check-label {
        white-space: nowrap;
        font-size: 14px;
    }


    .input-group {
        max-width: 500px;
        min-height: 45px;
        align-items: center;
    }
`;
export default function AddBranch(props) {
    const [dirty, setDirty] = useState(false);
    const form = useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {checkFieldConfirm} = useCheckDirtyField();
    const refresh = useRefresh();


    const onSubmit = form.handleSubmit((data) => {
        addBranchMutation.mutate();
    });
    
    // 지점 등록
    const addBranchMutation = useMutation({
        mutationKey: ['addBranch'],
        mutationFn: () => {
            const values = form.getValues();
            return axios("/branch/add", {
                method: "POST",
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                data: {
                    companyId: values.companyId,
                    branchName: values.branchName,
                    storeId: values.storeId,
                    ownerName: values.ownerName,
                    tel: values.branchTelArea + "-" + values.telNum,
                    registrationNo: values.registrationNo,
                    region: values.region,
                    address: values.address,
                    useIp: values.useIp,
                    ipList: values.ipList,
                    branchAdminList: values.branchAdminList,
                    generalAdminList: values.generalAdminList,
                    registrationFile: values.registrationFile[0], 
                    contractFile: values.contractFile.length > 0 ? values.contractFile[0] : "", 
                }
            }).then(result => {
                if (result.status == "201") {
                    dispatch(showAlert({
                        msg: "등록되었습니다.",
                        func: () => {
                            refresh.refetch();
                            navigate(-1);
                        }
                    }))
                } else {
                    dispatch(showAlert({
                        msg: <>요청을 처리하지 못했습니다. <br/>ERROR STATUS: {result.status}</>,
                    }))
                }
            }).catch(error => {
                dispatch(showAlert({
                    msg: error.response?.data?.msg?.ko ? error.response?.data?.msg?.ko : "처리 중 오류가 발생했습니다."
                }))
            })
        }
    });

    useEffect(() => {
        const subscription = form.watch((formValue) => {
            setDirty(true);
        });
        return () => subscription.unsubscribe();
    },[form.watch]);

    return (
        <Wrap>
            <PageTemplate.Top>
                <BreadCrumb arr={[<Link to="/admin/list/company">관리자 설정</Link>, <Link to="/admin/list/branch">지점 관리</Link>, <span className="fw-bold">지점 등록</span>]} />
                <h1 className="page-title">지점 등록</h1>
            </PageTemplate.Top>
            <PageTemplate.Content>
                <BranchForm form={form} selectCompany={true}/>
            </PageTemplate.Content>
            <PageTemplate.ButtonContainer className="mt-3">
                <Button className="me-2" variant="outline-secondary" onClick={() => {
                    checkFieldConfirm(dirty);
                }}>취소</Button>
                <Button type="button" variant="primary" onClick={() => {
                    onSubmit();
                }}>등록</Button>
            </PageTemplate.ButtonContainer>
        </Wrap>
    );
}
